/**
 * The treemap panel type and the settings it draws from.
 */

const treemap = {
  names: [{ id: 'treemap', label: 'Treemap', phrase: 'a treemap', guide: 'treemap.md', advanced: true, toolSummary: 'relative area across a larger parts-of-whole category set — one row per positive tile, capped at 50', promptSummary: 'which parts dominate across a larger category set — one row per positive tile, up to 50' }],
  block: 'treemap',
  /* Treemap. The query already returns one row per category; this block identifies the rectangle's
     label and positive numeric area. */
  fields: {
    labelKey: { kind: 'string', required: true, label: 'Tile label' },
    valueKey: { kind: 'string', required: true, label: 'Tile value' }
  },
  editorHint: 'One row is one tile. Aggregate and order the categories largest-first in SQL, and keep the result to the 50 categories that matter most.',
  stateSummary: ({ block }) => (block.labelKey && block.valueKey ? `treemap: ${block.labelKey} × ${block.valueKey}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['labelKey', 'valueKey'],
    description: 'Treemap mapping (displayType "treemap"): ONE ROW IS ONE TILE of a meaningful whole. Aggregate, order largest-first, and LIMIT 50 in the source SQL; the renderer also enforces 50 and reports anything it cannot draw. Read immutable/analytics/panel-types/treemap.md before configuring one.',
    properties: {
      labelKey: { type: 'string', description: 'Column naming the tile. Dot paths work.' },
      valueKey: { type: 'string', description: 'Column holding the positive numeric tile value. Dot paths work.' }
    }
  }
};

export default treemap;
